import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import useThemeStyles from '../../../hooks/useThemeStyles';

const ProfileCard = ({ fullName, onFullNameChange, email, onEmailChange, saving, onSave }) => {
  const { colors, components } = useThemeStyles();

  const cardStyle = {
    ...components.card,
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  };

  return (
    <Card id="profile-card" style={cardStyle}>
      <CardContent id="profile-content" sx={{ padding: 3 }}>
        <Box
          id="profile-header"
          sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 2 }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Profile
          </Typography>
        </Box>
        <Box id="profile-form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            id="profile-display-name-input"
            label="Display name"
            value={fullName}
            onChange={(e) => onFullNameChange(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{
              '& .MuiInputLabel-root': {
                color: colors.text.secondary,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: colors.interactive.primary,
              },
              '& .MuiOutlinedInput-input': {
                color: colors.text.primary,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: colors.border.subtle,
                },
                '&:hover fieldset': {
                  borderColor: colors.interactive.primary,
                },
                '&.Mui-focused fieldset': {
                  borderColor: colors.interactive.primary,
                },
              },
            }}
          />
          <TextField
            id="profile-email-input"
            label="Email address"
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{
              '& .MuiInputLabel-root': {
                color: colors.text.secondary,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: colors.interactive.primary,
              },
              '& .MuiOutlinedInput-input': {
                color: colors.text.primary,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: colors.border.subtle,
                },
                '&:hover fieldset': {
                  borderColor: colors.interactive.primary,
                },
                '&.Mui-focused fieldset': {
                  borderColor: colors.interactive.primary,
                },
              },
            }}
          />
          <Button
            id="save-profile-button"
            variant="contained"
            onClick={onSave}
            disabled={saving}
            sx={{
              alignSelf: 'flex-start',
              textTransform: 'none',
              borderRadius: '8px',
              padding: '10px 24px',
            }}
          >
            {saving ? <CircularProgress size={20} /> : 'Save Profile'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

ProfileCard.propTypes = {
  fullName: PropTypes.string.isRequired,
  onFullNameChange: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default ProfileCard;
